import React from 'react'
import { useTranslation } from 'react-i18next'
import Part from '../../../components/HomePart'
import Glass from '../../../components/Glass'
import './style.scss'
import System from '../../../store/system'

interface MemberProp {
  description: string
  name: string
  title: string
  avatar: string
}

const Member: React.FC<MemberProp> = ({ description, name, title, avatar }) => {
  const { isMobile } = System.useContainer()

  return (
    <Glass className="member" classic={isMobile}>
      <div className="description">{description}</div>
      <div className="info">
        <img src={avatar} alt="" />
        <div className="text">
          <div className="name">{name}</div>
          <div className="title">{title}</div>
        </div>
      </div>
    </Glass>
  )
}

const members: string[] = ['alex', 'sean', 'jack', 'martin']

const Team: React.FC = () => {
  const { t } = useTranslation('trans', { keyPrefix: 'team' })

  return (
    <Part id="team" title={t('title')}>
      <div className="members">
        {members.map((key) => (
          <Member
            key={key}
            description={t(`members.${key}.description`)}
            name={t(`members.${key}.name`)}
            title={t(`members.${key}.title`)}
            avatar={t(`members.${key}.avatar`)}
          />
        ))}
      </div>
    </Part>
  )
}

export default Team
